module.exports = __webpack_public_path__ + "static/img/login.38e33a40.jpg";